import { IStockOutIn } from "../../models/input/agendaApi/IStockOutIn";
import * as ApiWithToken from "../callApiWithToken";


const stockOutService = {
    getStockOut:async function(posCode:string){
        return ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API + `StockOut/getStockOutWeb?posCode=${posCode}`);
    },
    insertStockOut:async function(stockOutIn: IStockOutIn[]){
        return ApiWithToken.postApi(process.env.REACT_APP_AGENDAS_API + `StockOut/InsertStockOut`, stockOutIn);
    }
}
export default stockOutService;
